import { Button, Navbar } from "flowbite-react";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Logo from "../img/logo.png";

function SimpleNavbar() {
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <Navbar
      fluid={true}
      rounded={true}
      className="md:container md:mx-auto !px-8"
    >
      <Navbar.Brand href="/">
        <img src={Logo} className="mr-3 h-6 sm:h-9" alt="Discover Loan Logo" />
        {/* <span className="self-center whitespace-nowrap text-xl font-semibold dark:text-white">
          Flowbite
        </span> */}
      </Navbar.Brand>
      <div className="flex md:order-2">
        <Navbar.Toggle />
        <Button
          className="!bg-[#00ABA5] hover:shadow-lg hover:-translate-x-px hover:shadow-[#00ABA5]/50 ml-2 md:ml-12"
          onClick={() => navigate("/contactus")}
        >
          Contact us
        </Button>
      </div>
      <Navbar.Collapse className="custom-navbar">
        <Navbar.Link
          href="/"
          active={location.pathname === "/"}
          className={
            location.pathname === "/"
              ? "md:!text-[#00ABA5] md:font-bold !bg-[#00ABA5] md:!bg-transparent"
              : "md:!text-[#244566]"
          }
        >
          Home
        </Navbar.Link>
        <Navbar.Link
          href="/aboutus"
          active={location.pathname === "/aboutus"}
          className={
            location.pathname === "/aboutus"
              ? "md:!text-[#00ABA5] md:font-bold !bg-[#00ABA5] md:!bg-transparent"
              : "md:!text-[#244566]"
          }
        >
          About us
        </Navbar.Link>
        <Navbar.Link
          href="/services"
          active={location.pathname === "/services"}
          className={
            location.pathname === "/services"
              ? "md:!text-[#00ABA5] md:font-bold !bg-[#00ABA5] md:!bg-transparent"
              : "md:!text-[#244566]"
          }
        >
          Services
        </Navbar.Link>
        <Navbar.Link
          href="/career"
          active={location.pathname === "/career"}
          className={
            location.pathname === "/career"
              ? "md:!text-[#00ABA5] md:font-bold !bg-[#00ABA5] md:!bg-transparent"
              : "md:!text-[#244566]"
          }
        >
          Career
        </Navbar.Link>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default SimpleNavbar;
